import React from 'react';
import { makeStyles, fade } from '@material-ui/core/styles';

import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles(theme => ({
  root: {
    margin: theme.spacing(1),
    padding: theme.spacing(2, 3, 2, 3),
    backgroundColor: fade('#efeb6a', 0.5),
    borderRadius: theme.shape.borderRadius,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: '0 3px 6px 0 rgba(0, 0, 0, 0.16)',
    '& > *': {
      color: theme.palette.primary.main,
      textDecoration: 'none',
      fontWeight: 500
    }
  },
  message: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& > span[role=img]': {
      marginLeft: theme.spacing(1)
    }
  }
}));

const RTVFlashMessage = ({ emoji, emojiLabel, message, containerProps }) => {
  const classes = useStyles();
  return (
    <div className={classes.root} {...containerProps}>
      <Typography component="span" className={classes.message}>
        {message}
        {emoji !== undefined && (
          <span role="img" aria-label={emojiLabel}>
            {emoji}
          </span>
        )}
      </Typography>
    </div>
  );
};

export default RTVFlashMessage;
